import type React from 'react'
import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

import { expandTransparencyShapeTargets } from '@/lib/object-effects/expand-transparency-targets'
import { TRANSPARENCY_MIN, transparencyFromOpacity } from '@/lib/object-effects/transparency'

export type TransparencySelectionItem = { id: string; locked: boolean; value: number }

/** Every transparency target of the selection (group shells expand to their descendants). */
export function transparencySelectionItems(
  activeObjects: ShapeData[],
  allShapes: ShapeData[]
): TransparencySelectionItem[] {
  const shapeById = new Map(allShapes.map((shape) => [shape.id, shape]))
  const shapeTargets = expandTransparencyShapeTargets(activeObjects, allShapes)

  return shapeTargets.map((target) => ({
    id: target.id,
    locked: target.locked,
    value: transparencyFromOpacity(shapeById.get(target.id)?.opacity ?? target.opacity),
  }))
}

/** The committed transparency to fall back on: the first unlocked target's value. */
export function committedTransparencyFromManagers(
  activeObjects: ShapeData[],
  shapeManagerRef: React.RefObject<ShapeManagerRef | null> | undefined
): number {
  const sm = shapeManagerRef?.current
  const allShapes = sm?.getShapes() ?? activeObjects
  const items = transparencySelectionItems(activeObjects, allShapes).filter((item) => !item.locked)

  if (items.length === 0) return TRANSPARENCY_MIN

  return items[0].value
}
